"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
exports.PaymentMethodType = {
    Custom: "custom",
    Check: "check",
    BankAccount: "bankAccount",
    Na: "na",
    Card: "card",
    Bnpl: "bnpl",
    VirtualCard: "virtualCard",
    OffPlatform: "offPlatform",
    Utility: "utility",
};
